import React, { useEffect } from 'react';

import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import AfterSalesConsumptionHistory from '../afterSalesConsumptionHistory';
import afterSalesSettings from '../afterSalesSettings';
import * as afterSalesSettingsSelectors from '../afterSalesSettings/selectors';
import reportList from '../reportList';

const Container = ({
    afterSalesSettingsDataId,
    fetchAfterSalesSettings,
    selectedProjectId,
}) => {
    useEffect(() => {
        fetchAfterSalesSettings(selectedProjectId);
    }, [selectedProjectId]);

    if (!afterSalesSettingsDataId)
        return (
            <afterSalesSettings.Container
                canModify={true}
                selectedProjectId={selectedProjectId}
            />
        );

    return (
        <Grid container>
            <Grid size={{ md: 9, xs: 18 }}>
                <AfterSalesConsumptionHistory.Container
                    canDelete={true}
                    canModify={true}
                    selectedProject={{ id: selectedProjectId }}
                />
            </Grid>

            <Grid size={{ md: 9, xs: 18 }}>
                <reportList.Container
                    canDelete={true}
                    canModify={true}
                    selectedProjectId={selectedProjectId}
                />
            </Grid>
        </Grid>
    );
};

const mapStateToProps = createStructuredSelector({
    afterSalesSettingsDataId:
        afterSalesSettingsSelectors.getAfterSalesSettingsDataId,
});

const mapDispatchToProps = (dispatch) => ({
    fetchAfterSalesSettings: (projectId) =>
        dispatch(afterSalesSettings.actions.fetchAfterSalesSettings(projectId)),
});

Container.propTypes = {
    afterSalesSettingsDataId: PropTypes.string,
    fetchAfterSalesSettings: PropTypes.func,
    selectedProjectId: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
